import React from "react";
import { Input } from "antd";
import { labelStyle } from "../../@types/productInfo";

interface TextAreaProps {
  inputValue: string;
  setInputValue: (value: string) => void;
  title: string;
  placeholder: string;
  style?: React.CSSProperties;
  required?: boolean;
  rows?: number;
}

const TextAreaInput: React.FC<TextAreaProps> = ({
  inputValue,
  setInputValue,
  title,
  placeholder,
  style,
  required,
  rows = 4,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(e.target.value);
  };

  const isRequiredEmpty = required && inputValue.trim() === "";
  return (
    <div>
      <p
        style={{
          ...(labelStyle as React.CSSProperties),
          color: isRequiredEmpty ? "red" : "#75A7AD",
        }}>
        {title} {required && <span style={{ color: "red" }}>*</span>}
      </p>
      < Input.TextArea
        rows={3}
        className={`w-full px-3 py-2 border ${
          isRequiredEmpty ? "border-red-500" : "border-[#005D6E]"
        } focus:outline-none focus:ring-2 focus:ring-[#005D6E]`}
        style={{ ...style, borderRadius: "20px", fontSize:"18px" }}
        value={inputValue}
        placeholder={placeholder}
        onChange={handleChange}
      />
    </div>
  );
};

export default TextAreaInput;
